import { render, staticRenderFns } from "./MealSelection.vue?vue&type=template&id=61f34572"
import script from "./MealSelection.vue?vue&type=script&lang=js"
export * from "./MealSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports